import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { CreatePersonComponent } from 'app/dialogs/create-person/create-person.component';
import { CreateWorkerDialogComponent } from 'app/dialogs/create-worker-dialog/create-worker-dialog.component';
import { PersonService } from 'app/services/models/person.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-person-list',
  templateUrl: './person-list.component.html',
  styleUrls: ['./person-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PersonListComponent implements OnInit {

  constructor(
    private personService: PersonService,
    private modalService: NgbModal,
    private router: Router,
    private toastrService: ToastrService) { }
  @BlockUI('section-block') blockUI: NgBlockUI;
  rows: any;
  public pageBasic = 1;
  public selectedSize = 5;
  public basicSelectedOption: number = 5;
  public searchValue = '';
  totalCount: Number = 0;
  public ColumnMode = ColumnMode;

  isAdvancedChange: boolean = false;


  personExcel: any[] = [];
  isPersonsValid: boolean = false;
  allPersonsValid: boolean = true;

  async ngOnInit() {
    this.personService.event$.subscribe(async result => {
      await this.getAllPerson(this.pageBasic - 1, this.selectedSize, this.searchValue);
    })
    await this.getAllPerson(this.pageBasic - 1, this.selectedSize, this.searchValue);
  }

  async getAllPerson(page, size, search) {
    this.blockUI.start("Personeller yükleniyor..")
    const data = await this.personService.getAllPersons(page, size, search);
    console.log(data);
    this.rows = data.persons;
    this.totalCount = data.totalCount;
    this.blockUI.stop();
  }

  onActivate(event: any) {
    if (event.type === 'click' && event.row) {

      this.router.navigate([`/admin/update-worker/${event.row.id}`]);
    }
  }

  filterUpdate(event) {
    const val = event.target.value.toLowerCase();
    this.searchValue = val;
    setTimeout(async () => {

      await this.getAllPerson(this.pageBasic - 1, this.selectedSize, this.searchValue);
    }, 500);
  }

  async onPageChange(pageNumber: number) {
    await this.getAllPerson(this.pageBasic - 1, this.selectedSize, this.searchValue);
  }

  async onOptionChange() {
    this.selectedSize = Number(this.basicSelectedOption)
    await this.getAllPerson(this.pageBasic - 1, this.selectedSize, this.searchValue);
  }

  createPerson() {
    const modal = this.modalService.open(CreatePersonComponent, {
      size: 'ml',
      centered: true,
      windowClass: 'modal modal-success'
    });
    modal.componentInstance.data = {
      id: null,
      companyId: null
    };
  }

  createWorker() {
    const modal = this.modalService.open(CreateWorkerDialogComponent, {
      size: 'lg',
      centered: true,
      windowClass: 'modal modal-success'
    });
  }

  toggleAdvancedUpload(event: any) {
    this.isAdvancedChange = event.target.checked;
  }


  onFileChange(event: any) {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = (e: any) => {
      const data = e.target.result;
      const workbook = XLSX.read(data, { type: 'binary' });

      // İlk sayfayı al
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];

      // Verileri JSON formatına çevir
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      // Sütun başlıklarını ayarlamak için
      const persons = jsonData.slice(1).map(row => {

        return {
          name: row[0],
          lastName: row[1],
          mail: row[2],
          phoneNumber: row[3],
          Mission: row[4],
          Depertmant: row[5],
          Tc: row[6],
          workingStatus: row[7].toLowerCase() === 'evet',
          wage: row[8],
          birthDay: new Date(Math.round((row[9] - 25569) * 86400 * 1000)),
          emergenyContact: row[10],
          address: row[11],
          startDate: new Date(Math.round((row[12] - 25569) * 86400 * 1000))
        };
      }).filter(person => {
        // Check if all fields in the product are null or undefined
        return person.name || person.lastName || person.wage || person.workingStatus;
      });;

      const invalidProducts = persons.filter(person =>
        !person.name ||
        !person.lastName ||
        typeof person.wage !== 'number' ||
        person.workingStatus === undefined ||
        person.emergenyContact.length > 50
      );

      this.isPersonsValid = invalidProducts.length > 0 ? false : true;

      if (invalidProducts.length > 0) {
        this.toastrService.error('Bazı personeller uygun olmayan biçimde.');
      }

      this.personExcel = persons;

      console.log(this.personExcel);
    };

    reader.readAsBinaryString(file);
  }


  resetFileInput(fileInput: HTMLInputElement) {
    // Dosya girişi temizle
    fileInput.value = '';
    this.personExcel = [];
    this.isPersonsValid = false;
    this.allPersonsValid = true;
  }

  async saveProducts() {
    if (!this.isPersonsValid) {
      this.toastrService.error('Lütfen geçerli ürünler yükleyin.');
      return;
    } else {
      this.personExcel = this.personExcel.map(person => {
        const createPerson: any = {
          name: person.name.toString(),
          lastName: person.lastName.toString(),
          mail: person.mail.toString(),
          phoneNumber: person.phoneNumber.toString(),
          mission: person.Mission.toString(),
          depertmant: person.Depertmant.toString(),
          tc: person.Tc.toString(),
          workingStatus: person.workingStatus,
          wage: person.wage,
          birthDay: person.birthDay,
          emergenyContact: person.emergenyContact.toString(),
          address: person.address.toString(),
          startDate: person.startDate
        };
        return createPerson;
      });
      const response = await this.personService.createWorkers(this.personExcel);
      if (response.status) {
        this.toastrService.success(response.message);
        this.personService.sendEvent(true);
      } else {
        this.toastrService.error(response.message);
      }
    }

  }

}
